export default __webpack_public_path__ + "static/media/infographic-arrow-bottom.6ac94fbf.svg";